var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoLocationsAdded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 201,
    viewBox: "0 0 176 201",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "rd4yiexu1a",
    d: "M0 0h33.05v25.285H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.884 179.969a169.94 169.94 0 0 1 2.734-22.85 170.186 170.186 0 0 1 13.244-18.821c-5.267-4.63-10.908-9.258-17.043-13.678C106.295 106.227 31.876 78.833 2 106.306c3.853 40.388 77.52 69.744 108.06 72.449 7.517.81 14.81 1.139 21.824 1.214",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.884 179.969a169.94 169.94 0 0 1 2.734-22.85 170.186 170.186 0 0 1 13.244-18.821c-5.267-4.63-10.908-9.258-17.043-13.678C106.295 106.227 31.876 78.833 2 106.306c3.853 40.388 77.52 69.744 108.06 72.449 7.517.81 14.81 1.139 21.824 1.214z",
    stroke: "#000",
    strokeWidth: 2.073,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.1 125.274c3.844-3.856 2.12-10.436-2.864-10.839-11.246-.91-22.602-.219-33.788 2.234.47.29.952.559 1.42.854 9.18 5.757 17.688 11.757 25.588 17.825a351.432 351.432 0 0 1 9.644-10.074",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(94.573 175.715)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "9v8iqajhxb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rd4yiexu1a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.628.312C1.083.219.544.097 0 0c6.692 9.289 14.687 17.38 23.67 24.207 3.98 3.026 9.657-.725 9.369-6.16-.239-4.506-.39-9.153-.454-13.936C22.65 3.36 12.309 2.15 1.628.312",
    fill: "#080717",
    mask: "url(#9v8iqajhxb)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#080717",
    strokeWidth: 2.073,
    d: "m149.443 162.8-41.959-16.077"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6176F4",
    strokeWidth: 2.073,
    d: "m175 172.592-14.061-5.387M172.284 160.564l-14.061-5.387M164.937 179.724l-14.061-5.387"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.63 111.938c4.603 1.764 6.904 6.923 5.14 11.523a8.925 8.925 0 0 1-11.527 5.136 8.92 8.92 0 1 1 6.388-16.659",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.031 131.836c3.877-4.388 7.425-10.255 10.039-17.072 2.615-6.82 3.9-13.555 3.95-19.41-10.223 1.34-19.262 4.739-26.02 10.952.872 9.135 5.324 17.704 12.031 25.53",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.541 41.827-31.32-6.324-22.31-4.904a.474.474 0 0 0-.576.418c-.014.141-.316 3.504 2.477 4.9 1.06.531 3.382 1.293 5.756 2.01-.375.588-.977 1.8-.474 2.957.063.143.145.277.237.408-.408 1.336-.345 2.434.203 3.258.117.176.261.329.416.473a.47.47 0 0 0-.076.423c.042.13 1.047 3.157 3.125 3.609.175.038.35.056.528.056.46 0 .926-.132 1.396-.387.742.498 2.93 1.637 7.455 1.637 2.684 0 4.194-2.018 4.682-2.806l26.578 3.908a.475.475 0 0 0 .536-.379l1.74-8.697a.477.477 0 0 0-.373-.56",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.447 42.293-31.329-6.326-22.31-4.903s-.315 3.163 2.216 4.428c2.531 1.265 12.658 3.954 12.658 3.954M40.193 37.865s-3.508 4.27 4.035 4.745",
    stroke: "#000",
    strokeWidth: 1.902,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.148 44.982s-.048.633-1.869.475c-1.821-.16-3.384-1.265-2.473-4.112M54.435 44.824c-2.69.95-5.063-1.424-5.063-1.424s.159 1.322-.791 2.373c-1.117 1.236-3.323.949-3.323.949l-1.266-3.992 4.43-4.39 5.22.315M40.326 45.298s1.951 6.01 5.723 1.898",
    stroke: "#000",
    strokeWidth: 1.902,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.942 48.145s1.89 1.74 7.436 1.74c3.007 0 4.43-2.847 4.43-2.847l26.898 3.954",
    stroke: "#000",
    strokeWidth: 1.902,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.49 162.242s1.901 2.59 5.356 1.554c3.455-1.036 7.255-3.108 9.156-5.699 1.9-2.59 9.156-13.987 9.156-13.987l-15.548-5.698s-10.538 23.83-8.12 23.83",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.984 159.208 4.698 13.724-33.815 11.567c-2.84.971-5.06-3.982-3.372-7.364l18.138-16.28s5.921 6.915 14.35-1.647",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.108 159.571 3.356 9.803L25.65 180.94c-2.84.971-4.31-1.792-2.377-4.456l18.117-15.55s5.792 5.746 14.719-1.364",
    fill: "#6176F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.984 159.208 4.698 13.724-33.815 11.567c-2.84.971-5.06-3.982-3.372-7.364l18.138-16.28s5.921 6.915 14.35-1.647zM41.634 160.855l7.825-19.393M55.984 159.208l7.755-11.76",
    stroke: "#000",
    strokeWidth: 1.902,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6 92.65 79.096 94.8a19.952 19.952 0 0 0-15.87 11.58l-15.38 33.931 17.275 7.598 13.82-34.537 33.091-1.975c7.351-.44 13.017-6.649 12.78-14.007l-.264-8.195-20.731-4.835-4.837 3.454-33.517-5.154a19.8 19.8 0 0 0-18.546 7.296L43.7 94.03c2.763 0 13.475.345 25.221 3.108",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.304 97.398s14.425-4.187 26.301-3.971",
    stroke: "#FFF",
    strokeWidth: 1.902,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.997 17.664a13.087 13.087 0 0 0-3.353-1.567c-.615-.542-5.925-1.456-8.434-2.538-1.685-.727-2.676-2.583-3.33-4.096a7.806 7.806 0 0 0-.86-1.992C126.137 5.86 124.624 5 124.624 5a7.83 7.83 0 0 0-10.836 2.263 7.822 7.822 0 0 0 4.026 11.692c3.22 1.549 3.662 2.22 4.3 4.168.501 1.53.599 3.911.617 4.936a13.087 13.087 0 0 0 5.915 11.524c6.055 3.96 14.176 2.266 18.139-3.787 3.962-6.053 2.267-14.17-3.788-18.132",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.435 40.418c.056-.068.115-.133.17-.201 4.546-5.625 3.818-13.793-1.627-18.243a12.373 12.373 0 0 0-3.085-1.847c-.537-.589-5.604-1.963-7.924-3.255-1.557-.868-2.312-2.788-2.776-4.342a7.662 7.662 0 0 0-.61-2.043c-.678-1.67-2.053-2.653-2.053-2.653-2.496-2.04-5.808-3.083-8.495-1.519",
    stroke: "#FFF",
    strokeWidth: 1.902,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.08 34.61c4.046-7.866 1.553-17.208-5.566-20.866a13.24 13.24 0 0 0-3.898-1.283c-.733-.537-6.795-.707-9.706-1.56-1.954-.572-3.205-2.604-4.052-4.289a8.619 8.619 0 0 0-1.112-2.214c-1.112-1.76-2.882-2.52-2.882-2.52-4.253-2.186-9.66-.148-12.076 4.55",
    stroke: "#080717",
    strokeWidth: 1.902,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.95 15.79c1.344 8.21-4.226 15.956-12.44 17.3-8.214 1.343-15.962-4.225-17.307-12.436-1.344-8.21 4.226-15.957 12.44-17.3 8.215-1.343 15.964 4.225 17.307 12.436",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.703 46.083c.054.41-8.664 1.773-9.286 1.83-.323.028-7.406-14.383-7.6-14.586l8.455-7.791s7.913 16.653 8.43 20.547",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.703 46.083c.054.41-8.664 1.773-9.286 1.83-.323.028-7.406-14.383-7.6-14.586l8.455-7.791s7.913 16.653 8.43 20.547z",
    stroke: "#000",
    strokeWidth: 1.902,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.991 24.899a11.53 11.53 0 0 0 1.067-7.016c-1.036-6.33-7.01-10.623-13.344-9.588-4.944.808-8.633 4.63-9.525 9.277a11.58 11.58 0 0 0-2.656 9.441c1.035 6.33 7.01 10.624 13.343 9.588a11.56 11.56 0 0 0 7.831-5.104 4.481 4.481 0 0 0 8.343-2.89 4.48 4.48 0 0 0-5.059-3.708",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.991 24.899a11.53 11.53 0 0 0 1.067-7.016c-1.036-6.33-7.01-10.623-13.344-9.588-4.944.808-8.633 4.63-9.525 9.277a11.58 11.58 0 0 0-2.656 9.441c1.035 6.33 7.01 10.624 13.343 9.588a11.56 11.56 0 0 0 7.831-5.104 4.481 4.481 0 0 0 8.343-2.89 4.48 4.48 0 0 0-5.059-3.708z",
    stroke: "#000",
    strokeWidth: 1.902,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.56 24.418c1.013 1.822 3.837 2.273 5.368.857M99.257 15.686c.791-.145 3.078-.716 3.643 1.756M93.193 12.342c1.855.516 3.108 3.12 2.151 4.897-.427.793-1.548 2.1-3.24 2.873",
    stroke: "#000",
    strokeWidth: 1.902,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1 17.116c-.145.776.192 1.49.75 1.594.56.104 1.13-.44 1.274-1.218.144-.776-.192-1.49-.751-1.594-.559-.104-1.129.442-1.274 1.218M98.427 19.427c-.145.776.192 1.49.75 1.594.56.104 1.13-.441 1.275-1.219.143-.776-.193-1.49-.751-1.594-.56-.104-1.13.442-1.274 1.219",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.868 19.78c-.036 1.924-.189 3.846-.401 5.75-.02.164-.147.33-.33.307a14.193 14.193 0 0 1-4.764-1.453c-2.727-1.397-4.984-3.677-6.27-6.464-1.403-3.05-1.683-6.58-.754-9.811.103-.367.63-.224.611.11 1.272-.758 2.959-.518 4.287.02 1.48.597 2.751 1.583 3.947 2.621 1.297 1.117 2.446 2.27 3.039 3.917.578 1.6.664 3.324.635 5.004",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104.51 39.98 13.474-5.353 12.233 49.364-39.46 5.444 4.813-26.142a30.238 30.238 0 0 1 8.197-15.742l2.47-3.772-1.728-3.799z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.571 42.916c-1.382.46-27.18-3.224-27.18-3.224L82.627 55.81l23.034 1.841 6.91-14.735z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.387 57.045c1.435-3.997 4.27-9.18 9.85-13.266",
    stroke: "#FFF",
    strokeWidth: 1.902,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.64 42.618s6.708 2.41 1.92 12.759c-5.207 11.254-11.184 19.815-11.184 19.815L99.744 64.81l11.864-13.868s6.279-9.985 12.032-8.324",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m113.516 73.592-10.6-7.59a.476.476 0 0 0-.578.016l-7.175 5.853c-2.733-1.362-22.948-11.27-30.854-10.408-7.782.858-10.083 5.536-10.762 8.25-.566 2.271.166 4.05 1.913 4.64a.47.47 0 0 0 .408-.057c.306 1.34 1.059 2.518 2.256 2.885.037.01.074.013.11.016.389.971 1.376 1.991 3.42 3.11.03.016.063.014.095.023.354.682 1.006 1.265 2.144 1.661.42.147.825.22 1.214.22.458 0 .893-.1 1.304-.303 1.191-.588 1.76-1.832 1.943-2.315 2.288 1.469 5.946.209 6.838-.137 1.183.516 7.858 3.381 15.193 5.66l.522.21c1.485.602 3.035.896 4.57.896a12.063 12.063 0 0 0 7.963-3.014l10.113-8.872a.474.474 0 0 0-.037-.744",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 1.902,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m103.027 65.846 11.864-13.867M126.396 55.896c-6.178 10.105-12.886 17.632-12.886 17.632"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.852 78.504c2.09 2.661 7.35.437 7.35.437s7.208 3.2 15.362 5.733l.522.211a11.631 11.631 0 0 0 12.04-2.034l10.113-8.873M55.613 73.903c-1.767-.6-2.014-2.433-1.603-4.075.41-1.641 2.1-6.984 10.35-7.893 8.25-.91 30.865 10.498 30.865 10.498l7.414-6.046",
    stroke: "#000",
    strokeWidth: 1.902,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.177 66.684c-1.445.798-3.536 2.426-3.948 5.51-.254 1.894.513 4.066 2.034 4.531",
    stroke: "#000",
    strokeWidth: 1.902,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.533 69.953s-2.243 1.443-3.157 3.457c-1.017 2.245-2.025 3.999 2.508 6.48",
    stroke: "#000",
    strokeWidth: 1.902,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.62 73.279s-3.107 1.51-3.545 3.666c-.382 1.879-.534 3.723 1.974 4.598 2.51.875 3.656-1.486 3.908-2.25.252-.764-.864-2.119-1.891-1.207",
    stroke: "#000",
    strokeWidth: 1.902,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoLocationsAdded);
export default __webpack_public_path__ + "static/media/no-locations-added.d4776467e2cdde95c8d769beef8bf04c.svg";
export { ForwardRef as ReactComponent };